import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { FC } from 'react';

export const IconWorkaround: FC<{ className?: string; missingIconName: string; scaleFactor?: number }> = ({
  className,
  missingIconName,
  scaleFactor,
}) => {
  const theme = useSgBsTheme();
  return (
    <img
      src={`images/${missingIconName}_${theme}.png`}
      className={className}
      alt={missingIconName}
      width={32 * (scaleFactor ?? 1.0)}
      height={24 * (scaleFactor ?? 1.0)}
    />
  );
};
